@use '@design/design-tokens/typography/typography' as *;

.chartFooterRoot {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.footerItem {
  @include typography-v2-body-xs;
  color: var(--text-soft);
}
